/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GetMetropolitanStatisticalAreasInputJsonApiModel = {
  id: "",
  filters: {
    jsonApi: "hasOne",
    type: "metropolitan-statistical-area-filters",
  },
};
